export const GOOGLE_PAY_PAYMENT = 'GOOGLE_PAY_PAYMENT';
export const GOOGLE_PAY_PAYMENT__FAILURE = 'GOOGLE_PAY_PAYMENT__FAILURE';
export const GOOGLE_PAY_PAYMENT__RESET = 'GOOGLE_PAY_PAYMENT__RESET';
